var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"SectionSolar"}},[_c('SectionSplit',{attrs:{"headline":_vm.$t('headline'),"src":"../../assets/komanda.jpg"}},[_c('h4',[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_vm._l((_vm.$ta('paragraphs')),function(paragraph){return _c('p',{key:paragraph},[_vm._v(" "+_vm._s(paragraph)+" ")])})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }